import { t as o } from "../../../vendor-CPVnY93G.js";
const e = "global", t = o();
export {
  e as GLOBAL_SCOPE,
  t as IS_MAC
};
